import * as React from 'react';
import { SubmitPhoneFormContainer } from '../../containers/SubmitPhoneFormContainer';
import { MobileAuthForm } from '../../components/MobileAuthForm';

export const MobileAuthPage = () => {
  return <SubmitPhoneFormContainer Form={MobileAuthForm} label="main_login_block" />;
};
